// extracted by mini-css-extract-plugin
export default {"status-toggle":"status-toggle_status-toggle__Zf1jj"};